import React, { useCallback } from 'react';

import { PreviewPanelsProvider } from '@atlassian/preview-panels-api';

import { useCloseAllOpenSidePanels } from './useCloseAllOpenSidePanels';
import { useClosePreviewPanelOnUrlChange } from './useClosePreviewPanelOnUrlChange';

interface ConfluencePreviewPanelsProviderProps {
	children: React.ReactNode;
}

// Component that uses the URL change detection hooks inside the provider context
const UrlChangeDetector = () => {
	useClosePreviewPanelOnUrlChange();
	return null; // This component doesn't render anything
};

export const ConfluencePreviewPanelsProvider = ({
	children,
}: ConfluencePreviewPanelsProviderProps) => {
	const { closeAllOpenSidePanels } = useCloseAllOpenSidePanels();

	const onPreviewPanelOpen = useCallback(() => {
		// Add any additional logic here for opening preview panels.
	}, []);

	const onPreviewPanelClose = useCallback(() => {
		// Add any additional logic here for closing preview panels.
		closeAllOpenSidePanels();
	}, [closeAllOpenSidePanels]);

	return (
		<PreviewPanelsProvider
			onPreviewPanelOpen={onPreviewPanelOpen}
			onPreviewPanelClose={onPreviewPanelClose}
		>
			{/* URL change detection hooks need to be inside the provider to access context */}
			<UrlChangeDetector />
			{children}
		</PreviewPanelsProvider>
	);
};
